import { SectionHeading } from "./SectionHeading";

const STEPS = [
  { num: "01", title: "Premier échange", text: "Nous échangeons sur vos besoins, votre projet et vos contraintes." },
  { num: "02", title: "Visite technique", text: "Analyse sur site, relevés et identification des contraintes techniques." },
  { num: "03", title: "Étude &amp; devis", text: "Définition des solutions, chiffrage détaillé et planning prévisionnel." },
  { num: "04", title: "Préparation", text: "Organisation, commandes, coordination et protection du chantier." },
  { num: "05", title: "Réalisation", text: "Exécution des ouvrages avec suivi régulier et contrôle des points sensibles." },
  { num: "06", title: "Réception", text: "Contrôle final, échange avec le client et traitement des éventuelles réserves." },
];

export const Methode = () => (
  <section id="methode" data-testid="methode-section" className="border-y border-mineral bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        chapter="02 — Méthode"
        title="Une méthode claire, du premier échange à la réception."
        testId="methode"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-mineral border border-mineral">
        {STEPS.map((s) => (
          <div
            key={s.num}
            data-testid={`methode-step-${s.num}`}
            className="group bg-white p-8 lg:p-10 transition-colors duration-500 hover:bg-casse"
          >
            <span className="font-heading text-4xl font-semibold tracking-tight text-sable-deep/80 transition-colors duration-500 group-hover:text-sable-deep">
              {s.num}
            </span>
            <h3
              className="mt-6 font-accent text-sm font-medium tracking-[0.18em] uppercase text-nuit"
              dangerouslySetInnerHTML={{ __html: s.title }}
            />
            <p className="mt-3 text-sm leading-relaxed text-anthracite/70">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
